/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import store from "../../../store";
import {
  showSuccessSnackbar,
  showErrorSnackbar,
  showInfoSnackbar,
} from "../../../store/actions/ui";

/**
 * Unified toast/notification service
 * Routes all notifications through Redux for consistent behavior
 * 
 * @param {string} message - The message to display
 * @param {string} severity - "success" | "error" | "info" | "warning"
 */
export const showToast = (message, severity = "error") => {
  if (!message) return;

  switch (severity) {
    case "success":
      store.dispatch(showSuccessSnackbar(message));
      break;
    case "error":
      store.dispatch(showErrorSnackbar(message));
      break;
    case "info":
    case "warning":
    default:
      store.dispatch(showInfoSnackbar(message));
      break;
  }
};

// Legacy support - deprecated, will be removed in future
let showToastFn = null;

export const setShowToast = (fn) => {
  showToastFn = fn;
};

// Backward compatibility alias
export const showToastLegacy = (message, severity = "error") => {
  if (showToastFn) {
    showToastFn(message, severity);
  } else {
    showToast(message, severity);
  }
};
